import React, { useState } from 'react';

import {
    LANG_BG,
    LANG_EN,
    SHORT_BG,
    SHORT_EN,
    DEFAULT_LANGUAGE,
    STORE_SELECTED_LANGUAGE
} from './constants';

interface LanguageToggleProps {
    onLanguageChange: () => void;
}

const LanguageToggle: React.FC<LanguageToggleProps> = ({ onLanguageChange }) => {

    const [currentLanguage, setCurrentLanguage] = useState<string>(
        localStorage.getItem(STORE_SELECTED_LANGUAGE) || DEFAULT_LANGUAGE
    );

    const handleLanguageChange = () => {
        setCurrentLanguage(currentLanguage === LANG_EN ? LANG_BG : LANG_EN);
        onLanguageChange(); // Call the prop function to update state in App.tsx
    };

    return (
        <button className="language-toggle" onClick={handleLanguageChange}>
            {currentLanguage === LANG_EN ? SHORT_EN : SHORT_BG }
        </button>
    );
};

export default LanguageToggle;
